import RequestCache from '../../utils/request-cache';

export default class Client {
    constructor(parent) {
        this.parent = parent;
        this.cache = new RequestCache('car-pricing-client');
        this.controllers = {};        
    }

    flushCacheAll() {
        this.cache.removeAll();
    }

    flushCache(key) {
        this.cache.remove(key);
    }

    async getFinanceParams(capCode, price, deliveryCharge, ved, firstRegistration) {
        const key = `finance-params-${capCode}-${price}`;
        if (this.cache.has(key)) {
            return await this.cache.get(key);
        }

        const data = new FormData();
        data.set('type', 'init');
        data.set('capCode', capCode);
        data.set('price', price);
        data.set('deliveryCharge', deliveryCharge);
        data.set('ved', ved);
        data.set('firstRegistration', firstRegistration);
        
        const request = fetch('/gateway/api/finance', { method: 'POST', body: data });
        try {
            const result = await this.cache.set(key, request);
            return result;
        } catch (err) {
            console.error(err);
            return [];
        }
    }

    async getFinance(productToken, term, deposit, usage) {
        const data = new FormData();
        data.set('type', 'quote');
        data.set('productToken', productToken);
        data.set('term', term);
        data.set('deposit', deposit);
        data.set('usage', usage);

        const request = fetch('/gateway/api/finance', { method: 'POST', body: data });
        try {
            const response = await request;
            if (response.ok) {
                const result = await response.json();
                return result;
            }
        } catch (err) {
            console.error(err);
        }
    }

    async getCarPricing(ids) {
        const key = `car-pricing-${ids}`;        
        if (this.cache.has(key)) {
            return await this.cache.get(key);
        }
        const signal = this.abort('car-pricing');
        const request = fetch(`/gateway/api/car-pricing?ids=${encodeURIComponent(ids)}`, { signal });
        try {
            const result = await this.cache.set(key, request);
            return result;
        } catch (err) {
            console.error(err);
            return {};
        }
    }

    abort(key) {        
        this.controllers[key]?.abort('Previous request aborted - ', key);
        this.controllers[key] = new AbortController();
        return this.controllers[key].signal;
    }
}
